var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-card',{staticClass:"p-3"},[_c('h2',{staticClass:"text-xl font-medium"},[_vm._v(_vm._s(_vm.title))]),_c('h3',{staticClass:"font-semibold text-3xl"},[_vm._v(" "+_vm._s(_vm.total)+" ")]),_c('vue-apex-charts',{attrs:{"type":"area","height":"200","series":_vm.series,"options":_vm.chartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }